import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=0fd2a57f"
import script from "./speed.vue?vue&type=script&lang=js"
export * from "./speed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports